import { IconProps } from '@/components/CustomIcon/types';
import {
  DashboardIcon,
  LeftArrowIcon,
  MessageIcon,
  BellIcon,
  HomeworkIcon,
  SettingsIcon,
  ProfileIcon,
  GlobeIcon,
  MoonIcon,
  CheckIcon,
  MealIcon,
  OrganizationsIcon,
  AcademicCalendarIcon,
  AttendanceIcon,
  NoteIcon,
  EtudesIcon,
  ExamResultsIcon,
  LiveLessonsIcon,
  TimelineIcon,
  WorkCalendarIcon,
  SolverIcon,
  LessonsIcon,
} from '@/components/CustomIcon/icons';

export const iconMap = {
  dashboard: DashboardIcon,
  'left-arrow': LeftArrowIcon,
  message: MessageIcon,
  bell: BellIcon,
  homework: HomeworkIcon,
  settings: SettingsIcon,
  profile: ProfileIcon,
  globe: GlobeIcon,
  moon: MoonIcon,
  check: CheckIcon,
  meal: MealIcon,
  organizations: OrganizationsIcon,
  'academic-calendar': AcademicCalendarIcon,
  attendance: AttendanceIcon,
  note: NoteIcon,
  etudes: EtudesIcon,
  'exam-results': ExamResultsIcon,
  'live-lessons': LiveLessonsIcon,
  timeline: TimelineIcon,
  'work-calendar': WorkCalendarIcon,
  solver: SolverIcon,
  lessons: LessonsIcon,
} as const;

export type IconName = keyof typeof iconMap;

export interface CustomIconProps extends Omit<IconProps, 'size'> {
  name: IconName;
  size?: number | string;
  className?: string;
}

export const CustomIcon = ({
  name,
  size = 20,
  className,
  ...props
}: CustomIconProps) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent size={size} className={className} {...props} />;
};

export {
  DashboardIcon,
  LeftArrowIcon,
  MessageIcon,
  BellIcon,
  HomeworkIcon,
  SettingsIcon,
  ProfileIcon,
  GlobeIcon,
  MoonIcon,
  CheckIcon,
  MealIcon,
  OrganizationsIcon,
  AcademicCalendarIcon,
  AttendanceIcon,
  NoteIcon,
  EtudesIcon,
  ExamResultsIcon,
  LiveLessonsIcon,
  TimelineIcon,
  WorkCalendarIcon,
  SolverIcon,
  LessonsIcon,
};
export type { IconProps };
